(function () {
  'use strict';

  const GROOMER_POSITIONS = ['Groomer', 'Assistant Groomer'];

  function initForm(root) {
    const form = root.querySelector('[data-careers-form]');
    if (!form || form.dataset.careersInit === '1') return;
    form.dataset.careersInit = '1';

    const alerts = root.querySelector('[data-careers-alerts]');
    const submitBtn = root.querySelector('[data-careers-submit]');
    const resumeInput = root.querySelector('[data-careers-resume]');
    const positionSelect = root.querySelector('[data-careers-position]');
    const successTemplate = root.querySelector('[data-careers-success]');
    const conditionalFields = root.querySelectorAll('[data-careers-show-if]');
    const maxBytes = parseInt(form.dataset.maxBytes, 10) || 8 * 1024 * 1024;

    function setAlert(type, message) {
      if (!alerts) return;
      alerts.innerHTML = '';
      if (!message) return;
      const box = document.createElement('div');
      box.className = 'alert alert--' + type;
      box.setAttribute('role', type === 'error' ? 'alert' : 'status');
      box.textContent = message;
      alerts.appendChild(box);
      alerts.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function setSubmitting(isSubmitting) {
      if (!submitBtn) return;
      submitBtn.disabled = isSubmitting;
      submitBtn.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
    }

    function updateConditional() {
      const value = positionSelect ? positionSelect.value : '';
      conditionalFields.forEach((el) => {
        const triggers = (el.dataset.careersShowIf || '').split(',').map((s) => s.trim()).filter(Boolean);
        const visible = triggers.length === 0 || triggers.indexOf(value) !== -1;
        if (visible) {
          el.setAttribute('data-careers-visible', 'true');
          el.querySelectorAll('input, textarea, select').forEach((input) => {
            if (input.dataset.careersReqOriginal === 'true') {
              input.required = true;
            }
          });
        } else {
          el.setAttribute('data-careers-visible', 'false');
          el.querySelectorAll('input, textarea, select').forEach((input) => {
            if (input.required) input.dataset.careersReqOriginal = 'true';
            input.required = false;
            if (input.type !== 'hidden') input.value = '';
          });
        }
      });
    }
    if (positionSelect) {
      positionSelect.addEventListener('change', updateConditional);
      updateConditional();
    }

    // Flag selects as "filled" so their floating label moves up even without a `required` attribute.
    root.querySelectorAll('select.select').forEach((select) => {
      const syncFilled = () => {
        if (select.value && select.value !== '') {
          select.setAttribute('data-filled', 'true');
        } else {
          select.removeAttribute('data-filled');
        }
      };
      syncFilled();
      select.addEventListener('change', syncFilled);
    });

    function validateResume() {
      if (!resumeInput || !resumeInput.files || resumeInput.files.length === 0) {
        return { ok: false, message: 'Please attach your resume (PDF or Word).' };
      }
      const file = resumeInput.files[0];
      const nameLower = (file.name || '').toLowerCase();
      var accepted = false;
      if (nameLower.endsWith('.pdf')) accepted = true;
      else if (nameLower.endsWith('.doc')) accepted = true;
      else if (nameLower.endsWith('.docx')) accepted = true;
      if (!accepted) return { ok: false, message: 'Resume must be a PDF, .doc, or .docx file.' };
      if (file.size > maxBytes) {
        const mb = Math.round((maxBytes / 1024 / 1024) * 10) / 10;
        return { ok: false, message: 'Resume must be under ' + mb + ' MB.' };
      }
      return { ok: true };
    }

    function showSuccess() {
      if (successTemplate && successTemplate.content) {
        const clone = successTemplate.content.cloneNode(true);
        form.replaceWith(clone);
      } else {
        form.innerHTML = '<p>Thank you. Your application has been received.</p>';
      }
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      setAlert(null, null);

      // Browser-level required/pattern check before the network hop.
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const resumeCheck = validateResume();
      if (!resumeCheck.ok) {
        setAlert('error', resumeCheck.message);
        return;
      }

      if (!form.action) {
        setAlert('error', 'This form is not configured yet. Please email careers@petmax.ca.');
        return;
      }

      setSubmitting(true);

      try {
        const fd = new FormData(form);

        // Turnstile token is auto-included by the widget as `cf-turnstile-response`;
        // guard against an unsolved challenge.
        const turnstileEl = form.querySelector('.cf-turnstile');
        if (turnstileEl && typeof window.turnstile !== 'undefined') {
          const token = window.turnstile.getResponse(turnstileEl);
          if (!token) {
            setAlert('error', 'Please complete the spam-check challenge above.');
            setSubmitting(false);
            return;
          }
          // Ensure token is in the FormData even if the widget inserted it late.
          fd.set('cf-turnstile-response', token);
        }

        const response = await fetch(form.action, {
          method: 'POST',
          body: fd,
          credentials: 'omit',
          mode: 'cors',
        });

        let payload = null;
        try { payload = await response.json(); } catch (_) { /* ignore parse error */ }

        if (response.ok && payload && payload.ok) {
          showSuccess();
          return;
        }

        const msg = (payload && payload.error) || 'Something went wrong. Please email careers@petmax.ca.';
        setAlert('error', msg);

        // Reset Turnstile so the user can retry (tokens are single-use).
        if (typeof window.turnstile !== 'undefined' && turnstileEl) {
          try { window.turnstile.reset(turnstileEl); } catch (_) {}
        }
      } catch (err) {
        setAlert('error', 'Network error — please try again or email careers@petmax.ca.');
      } finally {
        setSubmitting(false);
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-careers-root]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init in Shopify theme editor when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-careers-root]').forEach(initForm);
  });
})();
